import config from '../../config';

export const aiHost = config.config.api_ai.merchant.host;

export const textOnlyBrokerChat = aiHost + '/gophr-broker/text-only-chat';